import { useLanguageContext } from "contexts/LanguageContext";
import {LanguageType} from "types/LanguageType";

export default function useCurrentLocale(): LanguageType {
    return useLanguageContext()
}